/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2024-11-14 15:22:13                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2025-01-13 17:59:04                               *
 *****************************************************************************/

/* SUMMARY
  * Imports
  * Components
  * Styles
  * QuotationDashdCard - display quotation on dashboard
*/

/* Imports */
import { CalendarIcon, MapPinIcon, UsersIcon } from "@heroicons/react/24/solid";
import { Typography } from "@material-tailwind/react";
/***/

/* Components */
import ContactDisplay from "../contact/ContactDisplay";
import AddressDisplay from "../address/AddressDisplay";
import DateDisplay from "../date/DateDisplay";
/***/

/* Styles */
import "./QuotationDashCard.scss";
import QuotationsStatusDisplay from "../quotation-status/QuotationsStatusDisplay";
import { t } from "../../../i18n";
/***/

/**
* QuotationDashdCard - display quotation on dashboard
* @param quotation - quotation data
* @param onClick - on click event
*/
export default function QuotationDashdCard({
  quotation,
  onClick
}: {
  quotation: EasyTech.Quotation,
  onClick?: () => void
}) {
  return(
    <div className="invoice-card" onClick={() => onClick && onClick()}>
      <div className="flex justify-between">
        <Typography className="text-blue-600 hover:underline">
          {quotation.ref}
        </Typography>
        <QuotationsStatusDisplay status={quotation.status}/>
      </div>

      <div className="icon-text-container">
        <div className="icon-text">
          <UsersIcon className="w-5"/>
          <ContactDisplay contact={quotation.contact} short={true}/>
        </div>

        {quotation.customer.address && (
          <div className="icon-text">
            <MapPinIcon className="w-5"/>
            <AddressDisplay address={quotation.customer.address}/>
          </div>
        )}

        <div className="icon-text">
          <CalendarIcon className="w-5"/>

          <Typography className="whitespace-nowrap">
            {t("common:scheduledOn")}
          </Typography>

          <DateDisplay date={new Date(quotation.date)}/>
        </div>
      </div>
    </div>
  );
}
/***/
